import { get, post, patch } from './client';

const BASE_URL = process.env.REACT_APP_AEGIS_URL ?? 'https://dev-api.degenaegis.com/v1';

export const getCampaigns = async () => {
  const res = await get(`${BASE_URL}/campaigns`);
  return res?.payload;
};

export const getCampaign = async campaignId => {
  const res = await get(`${BASE_URL}/campaigns/${campaignId}`);
  return res?.payload;
};

// Waitlist cap + expiry: the live budget of a campaign — for `allocated`
// (claims-cap) campaigns: solLimit, allocatedSol, allocatedCount, remainingSol,
// expireAt. Same Cognito authorizer as the risk-free-plays routes (not public).
// Until aegis ships the route it answers 404 — callers render "unavailable".
export const getCampaignBudget = async (campaignId, Authorization = '') => {
  const res = await get(`${BASE_URL}/campaigns/${campaignId}/budget`, { Authorization });
  return res?.payload;
};

export const createCampaign = async (body, Authorization = '') => {
  const res = await post(`${BASE_URL}/campaigns`, { ...body }, { Authorization });
  return res?.data?.payload;
};

// Aegis Track A — PATCH /v1/campaigns/{id}
// Auth: Cognito + LEGAL_WALLETS, same header as createCampaign.
// Body (at least one field; omit = leave unchanged):
//   { solLimit?: number, expireAt?: ISO-8601 }
// 200 payload: updated campaign (capMode, solLimit, expireAt, allocatedSol,
// allocatedCount; optional softFreezeAt / mutable / mutableReason).
// 400 CAMPAIGN_SOFT_FROZEN | SOL_LIMIT_BELOW_ALLOCATED | EXPIRE_AT_IN_PAST
//     | EXPIRE_AT_SHORTEN_FORBIDDEN | CAP_MODE_NOT_ALLOCATED.
// expireAt is extend-only (aegis#113 @ 0c3c4bfbdf837424ab13ef4abb74f66d41213a4e):
// shortening is HTTP 400, code exactly EXPIRE_AT_SHORTEN_FORBIDDEN.
// 403 / 404 as usual.
export const updateCampaign = async (campaignId, body, Authorization = '') => {
  const res = await patch(`${BASE_URL}/campaigns/${campaignId}`, { ...body }, { Authorization });
  return res?.data?.payload;
};

export const getRiskFreePlays = async (campaignId, Authorization = '') => {
  const res = await get(`${BASE_URL}/campaigns/${campaignId}/risk-free-plays`, { Authorization });
  return res?.payload;
};

export const createRiskFreePlays = async (campaignId, body, Authorization = '') => {
  const res = await post(
    `${BASE_URL}/campaigns/${campaignId}/risk-free-plays`,
    { ...body },
    { Authorization }
  );
  return res?.data?.payload;
};

export const getRiskFreePlaysOfWallet = async (walletId, Authorization = '') => {
  const res = await get(`${BASE_URL}/risk-free-plays?walletId=${walletId}&status=ALL`, {
    Authorization,
  });
  return res?.payload;
};

export const voidRiskFreePlay = async (campaignId, rfpId, Authorization = '') => {
  const res = await post(
    `${BASE_URL}/campaigns/${campaignId}/risk-free-plays/${rfpId}/void`,
    {},
    { Authorization }
  );
  return res?.data?.payload;
};

// Admin release of a stuck multiplayer lock. The server decides: it refuses
// a lock that is too fresh or still bound to a round. On success the grant
// is AVAILABLE again. 200 is `{ payload }`. A 400 body is `{ message }`.
// 403 and 404 often have no message; the wallet-search modal then says
// not allowed / not found.
export const releaseStuckRiskFreePlay = async (campaignId, rfpId, Authorization = '') => {
  const res = await post(
    `${BASE_URL}/campaigns/${campaignId}/risk-free-plays/${rfpId}/release`,
    {},
    { Authorization }
  );
  return res?.data?.payload;
};

export const reprocessRiskFreePlays = async (campaignId, rfpId, Authorization = '') => {
  const res = await post(
    `${BASE_URL}/campaigns/${campaignId}/risk-free-plays/${rfpId}/reprocess`,
    {},
    { Authorization }
  );
  return res?.data?.payload;
};
